<template>
  <b-form-group v-slot="{ ariaDescribedby }">
    <hr class="solid" />
    <b-row align-v="center" class="px-3">
      <b-col cols="4">
        <b-form-radio
          v-model="selected"
          :aria-describedby="ariaDescribedby"
          :disabled="radioButtonIsDisabled"
          name="some-radios"
          value="personal"
          >Personal
        </b-form-radio>
      </b-col>
      <b-col cols="8">
        <p class="float-right m-0">Create a new access request for yourself</p>
      </b-col>
    </b-row>
    <!-- personal form -->
    <!-- <validation-observer v-if="selected === 'personal'" ref="observer">
      <b-row>
        <b-col cols="8">
          <validation-provider
            ref="provider"
            v-slot="validationContext"
            :rules="{ required: true, regex: /^(\+)?([0-9]+)$/ }"
          >
            <b-form-input
              ref="phone"
              v-model="form.phoneNumber"
              :state="getValidationState(validationContext)"
              class="mt-4 rounded-pill"
              placeholder="Phone Number (with international code)"
              type="tel"
              @input="onFormUpdate"
            ></b-form-input>
            <b-form-invalid-feedback id="validationFeedback"
              >{{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
          </validation-provider>
        </b-col>
      </b-row>
    </validation-observer> -->
    <hr class="solid" />
    <b-row align-v="center" class="px-3">
      <b-col cols="4">
        <b-form-radio
          v-model="selected"
          :aria-describedby="ariaDescribedby"
          :disabled="radioButtonIsDisabled"
          name="some-radios"
          value="otherUser"
          >Other User
        </b-form-radio>
      </b-col>
      <b-col cols="8">
        <p class="float-right m-0">Create a request for another user</p>
      </b-col>
    </b-row>
    <!-- other user form -->
    <validation-observer v-if="selected === 'otherUser'" ref="observer">
      <b-row class="mt-2">
        <b-col>
          <validation-provider ref="provider" v-slot="validationContext" rules="required">
            <b-form-input
              ref="firstName"
              v-model="form.firstName"
              :state="getValidationState(validationContext)"
              class="mt-4 rounded-pill"
              placeholder="First Name"
              @input="onFormUpdate"
            ></b-form-input>
            <b-form-invalid-feedback id="validationFeedback"
              >{{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
          </validation-provider>
        </b-col>
        <b-col>
          <validation-provider ref="provider" v-slot="validationContext" rules="required">
            <b-form-input
              ref="lastName"
              v-model="form.lastName"
              :state="getValidationState(validationContext)"
              class="mt-4 rounded-pill"
              placeholder="Last Name"
            ></b-form-input>
            <b-form-invalid-feedback id="validationFeedback"
              >{{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
          </validation-provider>
        </b-col>
      </b-row>
      <!-- <b-row>
        <b-col cols="8">
          <validation-provider
            ref="provider"
            v-slot="validationContext"
            :rules="{ required: true, regex: /^(\+)?([0-9]+)$/ }"
          >
            <b-form-input
              ref="phone"
              v-model="form.phoneNumber"
              :state="getValidationState(validationContext)"
              class="mt-4 rounded-pill"
              placeholder="Phone Number (with international code)"
              type="tel"
              @input="onFormUpdate"
            ></b-form-input>
            <b-form-invalid-feedback id="validationFeedback"
              >{{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
          </validation-provider>
        </b-col>
      </b-row> -->
      <b-row>
        <b-col>
          <validation-provider
            ref="provider"
            v-slot="validationContext"
            rules="required|email"
            vid="confirm"
          >
            <b-form-input
              ref="email"
              v-model="form.selectedEmail"
              :state="getValidationState(validationContext)"
              class="mt-4 rounded-pill"
              placeholder="New user's email"
              type="email"
              @input="onFormUpdate"
            ></b-form-input>
            <b-form-invalid-feedback id="validationFeedback"
              >{{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
          </validation-provider>
        </b-col>
        <b-col>
          <validation-provider v-slot="validationContext" rules="required|confirmed:confirm">
            <b-form-input
              ref="confirmEmail"
              v-model="form.confirmEmail"
              :state="getValidationState(validationContext)"
              class="mt-4 rounded-pill"
              placeholder="Confirm Email"
              type="email"
              @input="onFormUpdate"
            ></b-form-input>
            <b-form-invalid-feedback id="validationFeedback"
              >{{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
          </validation-provider>
        </b-col>
      </b-row>
    </validation-observer>
    <hr class="solid" />
  </b-form-group>
</template>
<script>
  export default {
    name: 'access-request-form',
    props: {
      radioButtonIsDisabled: { type: Boolean, default: () => false },
    },
    data() {
      return {
        selected: '',
        form: {
          firstName: '',
          lastName: '',
          //  phoneNumber: '',
          selectedEmail: '',
          confirmEmail: '',
        },
      };
    },
    watch: {
      selected(newVal, oldVal) {
        if (newVal === 'personal') {
          this.$emit('onFormUpdate', {
            // phoneNumber: this.form.phoneNumber,
            firstName: window.Laravel.user_firstName,
            lastName: window.Laravel.user_lastName,
            selectedEmail: window.Laravel.user_email,
          });
        } else if (newVal !== oldVal) {
          this.form = {};
          this.$emit('onFormUpdate', this.form);
          this.$emit('requestType', this.selected);
        }
      },
    },
    methods: {
      getValidationState({ dirty, validated, valid = null, required }) {
        if (required) {
          return dirty || validated ? valid : null;
        }
      },
      async onFormUpdate() {
        const isValid = await this.$refs.observer.validate();
        if (isValid) {
          this.emitForm();
        } else {
          this.$emit('onFormUpdate', {});
        }
      },
      emitForm() {
        if (this.selected === 'personal') {
          this.$emit('onFormUpdate', {
            // phoneNumber: this.form.phoneNumber,
            firstName: window.Laravel.user_firstName,
            lastName: window.Laravel.user_lastName,
            selectedEmail: window.Laravel.user_email,
          });
        } else {
          this.$emit('onFormUpdate', this.form);
        }
      },
    },
  };
</script>
